import React from "react";
import { useFormLoyaltyConfirmHook } from "./form-loyalty-confirm-hooks";

type ContextFormLoyaltyConfirm = ReturnType<typeof useFormLoyaltyConfirmHook>;
export const FormLoyaltyConfirmContext =
  React.createContext<ContextFormLoyaltyConfirm | null>(null);

export function useContextFormLoyaltyConfirm() {
  const context = React.useContext(FormLoyaltyConfirmContext);

  if (!context) {
    throw new Error(
      "useContextFormLoyaltyConfirm must be used within a ContextFormLoyaltyConfirmProvider",
    );
  }

  return context;
}
